import React from "react";

const Chapter7 = () => {
  return (
    <>
      <h2>Impacts of storm runoff?</h2>
      <p>
        Storm runoff carries metals and other trace elements from urban areas,
        manufacturing plants, mining sites, and sediment to water ways. As the
        water runs over rocks and sediment they start to break down and are
        carried away with the water. The metals and trace elements found in
        those rocks then enter the waterways. While this occurs naturally with
        rocks and sediment, issues are exacerbated by human sources of trace
        elements. Mining facilities expose large amounts of rock and metals, so
        storm runoff from those sites contains higher levels of trace elements
        than would naturally occur. Some elements like selenium are associated
        with mining facilities.
      </p>
    </>
  );
};

export default Chapter7;
